import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('617Reach app error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#FAF8F5] flex flex-col" data-testid="error-boundary-page">
          <div className="flex-1 flex items-center justify-center px-4">
            <div className="max-w-md text-center">
              <img src="/brand-icon.png" alt="617Reach" className="w-16 h-16 mx-auto mb-6 rounded-2xl shadow-md" />
              <h1 className="text-3xl font-bold text-[#1A1A1A] mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Something went off route
              </h1>
              <p className="text-[#5A5A5A] mb-8 leading-relaxed">
                An unexpected error happened on our side — your information is safe. Reloading the page usually gets things back on track.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <button
                  data-testid="error-reload-btn"
                  onClick={() => window.location.reload()}
                  className="bg-[#5C4023] hover:bg-[#4A331C] text-white rounded-full h-11 px-6 font-medium transition-colors"
                >
                  Reload Page
                </button>
                <button
                  data-testid="error-home-btn"
                  onClick={() => { window.location.href = '/'; }}
                  className="border border-[#E0D6C8] text-[#5C4023] hover:bg-[#F3EFE9] rounded-full h-11 px-6 font-medium transition-colors bg-white"
                >
                  Return Home
                </button>
              </div>
            </div>
          </div>
          <img src="/skyline-band.jpg" alt="" aria-hidden="true" className="w-full max-h-36 object-cover object-top opacity-60 pointer-events-none select-none" />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
